import { render, staticRenderFns } from "./_section.vue?vue&type=template&id=b7928c00&scoped=true&"
import script from "./_section.vue?vue&type=script&lang=js&"
export * from "./_section.vue?vue&type=script&lang=js&"
import style0 from "./_section.vue?vue&type=style&index=0&id=b7928c00&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7928c00",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {MasterpieceSelect: require('/home/bitrix/frontend/components/profile/MasterpieceSelect.vue').default,ProfileAvatar: require('/home/bitrix/frontend/components/profile/ProfileAvatar.vue').default,Button: require('/home/bitrix/frontend/components/other/Button.vue').default,LeftAside: require('/home/bitrix/frontend/components/other/LeftAside.vue').default,AchievementsModal: require('/home/bitrix/frontend/components/profile/AchievementsModal.vue').default,MtModalFull: require('/home/bitrix/frontend/components/Modal/MtModalFull.vue').default,ProfileMenu: require('/home/bitrix/frontend/components/profile/ProfileMenu.vue').default,SidebarAnchors: require('/home/bitrix/frontend/components/other/SidebarAnchors.vue').default,MtInput: require('/home/bitrix/frontend/components/form/MtInput.vue').default,MtModal: require('/home/bitrix/frontend/components/Modal/MtModal.vue').default,ProfileDetail: require('/home/bitrix/frontend/components/profile/ProfileDetail.vue').default,Settings: require('/home/bitrix/frontend/components/profile/Settings.vue').default,ProfileGallery: require('/home/bitrix/frontend/components/profile/ProfileGallery.vue').default,Preloader: require('/home/bitrix/frontend/components/other/Preloader.vue').default})
